export default __webpack_public_path__ + "products-filter.v17/ico_search.70285263.svg";